import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";

interface Props {
  /** Light text for dark backgrounds (hero, auth page). */
  dark?: boolean;
  className?: string;
}

/** EN | BG toggle. The choice is remembered only with "preferences" cookie consent (see i18n/index.ts). */
export default function LanguageSwitcher({ dark = false, className = "" }: Props) {
  const { i18n, t } = useTranslation();
  const active = i18n.resolvedLanguage === "bg" ? "bg" : "en";

  return (
    <div
      role="group"
      aria-label={t("common.language")}
      className={`inline-flex items-center rounded-full p-0.5 text-xs font-semibold ${
        dark ? "bg-background-50/10" : "bg-background-200/70"
      } ${className}`}
    >
      {LANGUAGES.map((lang) => {
        const selected = lang.code === active;
        return (
          <button
            key={lang.code}
            type="button"
            lang={lang.code}
            title={lang.name}
            aria-pressed={selected}
            onClick={() => void i18n.changeLanguage(lang.code)}
            className={`rounded-full px-2.5 py-1 transition-colors cursor-pointer ${
              selected
                ? dark
                  ? "bg-background-50 text-foreground-950"
                  : "bg-background-50 text-foreground-950 shadow-sm"
                : dark
                  ? "text-background-50/70 hover:text-background-50"
                  : "text-foreground-600 hover:text-foreground-950"
            }`}
          >
            {lang.label}
          </button>
        );
      })}
    </div>
  );
}
